import PageLayout from 'pages/StudentViewAssignmentFeedback/PageLayout';
import PageProvider from 'pages/StudentViewAssignmentFeedback/PageProvider';

const StudentViewAssignmentFeedbackPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default StudentViewAssignmentFeedbackPage;
